<div class="form-group">
  <label>{{ to.label }}</label>
  <nouislider [min]="1" [max]="5" [step]="1" [tooltips]="true" [formControl]="this.formControl"
    [formlyAttributes]="field"></nouislider>
</div>
